import axios from 'axios';
import apiConfig from '../../api.config';

export default function getBookingReportConfig({ hotelId }) {
  const {
    host,
    URIs: { policeReport, bookingReportConfig },
  } = apiConfig;

  const uri = `${host}${policeReport}/${bookingReportConfig.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
